import React from 'react'
import './MentionsLegales.css';

const MentionsLegales: React.FC = () => {
    return (
        <div className="mentionslegales-page">
            <div className="mentionslegales-custom-container">
                <h1 className="mentionslegales-custom-title-h1">Charte RSE de Centralis</h1>
                <h2 className="mentionslegales-custom-title-h2">Mise à jour le 17 juin 2025</h2>

                <h3 className="mentionslegales-custom-title-h3">Préambule</h3>
                <p className="mentionslegales-custom-paragraph">
                    En tant que centrale nationale d'achats publics dédiée à la rénovation du patrimoine, Centralis se positionne comme un acteur engagé au service de la commande publique durable. Fidèle à ses valeurs d'intérêt général, l'association place la responsabilité sociétale au cœur de son action : respect des personnes, préservation de l'environnement, équité économique et loyauté des pratiques.
                </p>
                <p className="mentionslegales-custom-paragraph">
                    La présente charte formalise les engagements de Centralis et de ses parties prenantes autour de quatre piliers structurants.
                </p>

                <h3 className="mentionslegales-custom-title-h3">Pilier 1 : Responsabilité sociale – Valoriser et préserver notre capital humain</h3>
                <ul className="mentionslegales-custom-ul">
                    <li>Engagement 1 : Favoriser des conditions de travail humaines et bienveillantes</li>
                    <li>Engagement 2 : Adapter le temps de travail</li>
                    <li>Engagement 3 : Prévenir les risques pour la santé et la sécurité</li>
                    <li>Engagement 4 : Favoriser l'expression et la participation</li>
                    <li>Engagement 5 : Soutenir la formation et la montée en compétences</li>
                </ul>

                <h3 className="mentionslegales-custom-title-h3">Pilier 2 : Responsabilité environnementale – Améliorer nos performances écologiques</h3>
                <ul className="mentionslegales-custom-ul">
                    <li>Engagement 6 : Intégrer des critères environnementaux dans tous nos marchés</li>
                    <li>Engagement 7 : Prévenir toutes formes de pollution</li>
                    <li>Engagement 8 : Contribuer à l'économie circulaire</li>
                    <li>Engagement 9 : Réduire notre empreinte carbone</li>
                    <li>Engagement 10 : Protéger la biodiversité</li>
                </ul>

                <h3 className="mentionslegales-custom-title-h3">Pilier 3 : Responsabilité territoriale – Œuvrer pour des territoires solidaires et équilibrés</h3>
                <ul className="mentionslegales-custom-ul">
                    <li>Engagement 11 : Impliquer les parties prenantes</li>
                    <li>Engagement 12 : Rendre l'achat public accessible au plus grand nombre</li>
                    <li>Engagement 13 : Répartir équitablement les opportunités</li>
                    <li>Engagement 14 : Garantir l'égalité de traitement entre les prestataires</li>
                    <li>Engagement 15 : Assurer des pratiques loyales et équitables</li>
                </ul>

                <h3 className="mentionslegales-custom-title-h3">Pilier 4 : Responsabilité économique – Optimiser la performance au service de l'intérêt général</h3>
                <ul className="mentionslegales-custom-ul">
                    <li>Engagement 16 : Équilibrer les comptes sans but lucratif</li>
                    <li>Engagement 17 : Offrir un service abordable et utile</li>
                    <li>Engagement 18 : Sécuriser nos actifs matériels et numériques</li>
                    <li>Engagement 19 : Rendre le service plus simple et plus réactif</li>
                    <li>Engagement 20 : Respecter scrupuleusement les délais de paiement</li>
                </ul>

                <h3 className="mentionslegales-custom-title-h3">Suivi et amélioration continue</h3>
                <p className="mentionslegales-custom-paragraph">
                    Centralis publie chaque année un bilan RSE synthétique présentant les actions engagées, les objectifs atteints ou non, et les axes d'amélioration. Cette démarche est supervisée par l'assemblée générale, avec le soutien du référent déontologue.
                </p>

                <h3 className="mentionslegales-custom-title-h3">Conclusion</h3>
                <p className="mentionslegales-custom-paragraph">
                    La charte RSE de Centralis incarne la volonté de l'association d'être un acteur responsable, fidèle à ses valeurs fondatrices : transparence, équité, sobriété, solidarité. Chaque membre, partenaire ou prestataire est invité à respecter et promouvoir ces engagements dans ses actions quotidiennes.
                </p>
            </div>
        </div>
    )
}

export default MentionsLegales